import { Component, Input, Output, EventEmitter } from "@angular/core";

import { BaseComponent } from "../base.component";
import { Observable } from "rxjs/Observable";
import { of } from "rxjs/observable/of";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/operator/distinctUntilChanged";
import "rxjs/add/operator/do";
import "rxjs/add/operator/map";
import "rxjs/add/operator/switchMap";
import "rxjs/add/operator/merge";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { SessionManagerService } from "../_services/SessionManager/session-manager.service";
import { DataService } from "../_services/data.service";
import { AlertService } from "../_services/alert.service";

@Component({
  selector: "searchparent",
  moduleId: module.id,
  templateUrl: "searchparent.component.html",
})
export class SearchParentComponent extends BaseComponent {
  @Output() parentSelected?: EventEmitter<any> = new EventEmitter();
  model: any;
  modalReference: any;
  searching: boolean;
  searchFailed: boolean;
  hideSearchingWhenUnsubscribed = new Observable(
    () => () => (this.searching = false)
  );

  constructor(
    private modalService: NgbModal,
    public dataService: DataService,
    private alertService: AlertService,
    public sessionManager: SessionManagerService
  ) {
    super(dataService, sessionManager);
    this.searching = false;
  }

  public formatter = (parent: { firstName: string; lastName: string }) =>
    parent.firstName +
    (parent.firstName &&
    parent.firstName != "" &&
    parent.lastName &&
    parent.lastName != ""
      ? " "
      : "") +
    parent.lastName;

  run() {}

  open(content) {
    this.clearSearch();
    let options: NgbModalOptions = {
      windowClass: "modal-opened searchParent",
    };
    this.modalReference = this.modalService.open(content, options);
  }

  searchParent() {}

  clearSearch() {
    setTimeout(() => {
      this.model = { firstName: "", lastName: "" };
    }, 700);
    if (this.modalReference) this.modalReference.close();
  }

  select(event) {
    let parent = event.item;
    this.clearSearch();

    if (this.parentSelected) {
      this.parentSelected.emit(parent);
    }
  }

  search = (text$: Observable<string>) =>
    text$
      .debounceTime(300)
      .distinctUntilChanged()
      .do(() => (this.searching = true))
      .switchMap((term) =>
        this.dataService
          .searchParent(term)
          .do(() => (this.searchFailed = false))
          .catch(() => {
            this.searchFailed = true;
            return of([]);
          })
      )
      .do(() => (this.searching = false))
      .merge(this.hideSearchingWhenUnsubscribed);
}



// WEBPACK FOOTER //
// ./src/app/registereduser/searchparent.component.ts